import Step01 from "./01Step";

export const formSteps = {
  1: Step01,
};
